import React from "react";
import Container from "../Component/Container";
import Header from "../Component/Header";

export default function VideoList() {
  return (
    <>
      <Header />
      <Container />
    </>
  );
}
